import React, { createContext, useContext, useEffect, useState } from 'react';
import { getSettings } from '../service/settingsService';

const SettingsContext = createContext({ settings: {}, loading: true });

export function SettingsProvider({ children }) {
    const [settings, setSettings] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getSettings()
            .then(setSettings)
            .catch(() => setSettings({}))
            .finally(() => setLoading(false));
    }, []);

    return (
        <SettingsContext.Provider value={{ settings, loading }}>
            {children}
        </SettingsContext.Provider>
    );
}

export function useSettings() {
    return useContext(SettingsContext);
}
